import React, {useContext} from 'react'
import Card from './shared/Card'
import propTypes from 'prop-types'
import {FaTimes, FaEdit} from 'react-icons/fa'
import FeedbackContext from '../context/FeedbackContext'

// function FeedbackItem({item, handleDelete}) {
function FeedbackItem({item}) {
  const {deleteFeedback, editFeedback} = useContext(FeedbackContext);
  return (
    <Card className="card">
        <div className="num-display">{item.rating}</div>
        {/* handleDelete dipanggil dari props dan mengirimkan id */}
        <button className="close" onClick={() => deleteFeedback(item.id)}>
          <FaTimes color="purple" />
        </button>
        <button className="edit" onClick={() => editFeedback(item)}>
          <FaEdit color="purple" />
        </button>
        <div className="text-display">
            {item.text}
        </div>
    </Card>
  )
}

FeedbackItem.propTypes = {
  item: propTypes.object.isRequired
}

export default FeedbackItem